<div class="title" mat-dialog-title>
  <h5>Domain names: no screenshots available</h5>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <div class="message">
    <p>
      We could not generate screenshots for any domain results. This may
      indicate a temporary network issue rather than an issue with the domains
      themselves.
    </p>

    <p>
      Please spot-check some of the results to confirm if the site is
      accessible.
    </p>

    <p>
      If all results show as not accessible, and results are relevant to be
      included in the report, rerun the search to see if this resolves the
      issue.
    </p>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    class="cdx-but-md cdx-but-link"
    color="primary"
    mat-button
    class="continue-button"
    (click)="onContinue()"
  >
    Continue
  </button>
</mat-dialog-actions>
